import { combineReducers } from 'redux';

import companyUsers from './companyUsers';

const rootUserManagementReducer = combineReducers({
  companyUsers,
});

export default rootUserManagementReducer;
